<!--统计数据-->
<template>
    <div>
        <div class="m-portlet">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">统计数据</h3>
                    </div>
                </div>
            </div>


            <div class="m-portlet__body">
                <div class="m-portlet">
                    <div class="m-portlet__body">
                        <el-form style="margin-bottom: -30px">
                            <div style="float: left;width: 300px">
                                <el-form-item label="筛选学期">
                                    <el-select v-model="semester" clearable placeholder="请选择学期"
                                               @change="changeSemester(semester)"
                                               :disabled="semesterDisabled">
                                        <el-option
                                                v-for="item in semesters"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div style="margin-left: 350px;">
                                <el-form-item label="选择日期">
                                    <el-date-picker
                                            v-model="date"
                                            type="daterange"
                                            align="right"
                                            unlink-panels
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd"
                                            :clearable="true"
                                            :picker-options="pickerOptions2"
                                            @change="changeDate(date)"
                                            :disabled="dateDisabled">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                        </el-form>
                        <!--<el-row>-->
                            <!--<el-col :span="1">筛选学期：-->
                                <!--<el-select v-model="semester" clearable placeholder="请选择学期"-->
                                           <!--@change="changeSemester(semester)"-->
                                           <!--:disabled="semesterDisabled">-->
                                    <!--<el-option-->
                                            <!--v-for="item in semesters"-->
                                            <!--:key="item.id"-->
                                            <!--:label="item.name"-->
                                            <!--:value="item.id">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-col>-->
                            <!--<el-col :span="6">-->
                                <!--<div class="block">-->
                                    <!--<span class="demonstration">选择日期</span>-->
                                    <!--<el-date-picker-->
                                            <!--v-model="date"-->
                                            <!--type="daterange"-->
                                            <!--align="right"-->
                                            <!--unlink-panels-->
                                            <!--range-separator="至"-->
                                            <!--start-placeholder="开始日期"-->
                                            <!--end-placeholder="结束日期"-->
                                            <!--value-format="yyyy-MM-dd"-->
                                            <!--:clearable="true"-->
                                            <!--:picker-options="pickerOptions2"-->
                                            <!--@change="changeDate(date)"-->
                                            <!--:disabled="dateDisabled">-->
                                    <!--</el-date-picker>-->
                                <!--</div>-->
                            <!--</el-col>-->
                        <!--</el-row>-->
                    </div>
                </div>
                <div class="m-portlet">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text">每日直接数据</h3>
                            </div>
                        </div>
                    </div>

                    <div class="m-portlet__body">
                        <table class="table table-striped" v-loading="loading" style="table-layout:fixed" width="100%">
                            <thead>
                            <tr>
                                <th width="120">类型</th>
                                <th width="50" v-for="directData in directDatas">{{directData.date}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!--每日整体学生数-->
                            <tr>
                                <td width="120">
                                    <i v-if="studentNumbers" class="el-icon-arrow-down"
                                       v-on:click="showDateStudentNumber"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateStudentNumber"></i>
                                    每日学生数
                                </td>
                                <td width="50" v-for="directData in directDatas">{{directData.dateStudentNumber}}</td>
                            </tr>
                            <!--每日每年级学生数-->
                            <tr v-if="studentNumbers">
                                <td><i v-if="studentNumbers_grade" class="el-icon-arrow-down"
                                       v-on:click="showDateStudentNumber_grades"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateStudentNumber_grades"></i>年级
                                </td>
                            </tr>
                            <tr v-for="grade in grades" v-if="studentNumbers_grade&&studentNumbers">
                                <td>{{grade.name}}</td>
                                <td v-for="directDataGrade in directDataGrades" v-if="directDataGrade.grade_id===grade.id">
                                    {{directDataGrade.dateStudentNumber}}
                                </td>
                            </tr>
                            <!--每日每科目的学生数-->
                            <tr v-if="studentNumbers">
                                <td><i v-if="studentNumbers_subject" class="el-icon-arrow-down"
                                       v-on:click="showDateStudentNumber_subjects"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateStudentNumber_subjects"></i>科目
                                </td>
                            </tr>
                            <tr v-for="subject in subjects" v-if="studentNumbers_subject&&studentNumbers">
                                <td>{{subject.name}}</td>
                                <td v-for="directDataSubject in directDataSubjects"
                                    v-if="directDataSubject.subject_id===subject.id">{{directDataSubject.dateStudentNumber}}
                                </td>
                            </tr>
                            <!--每日每班型的学生数-->
                            <tr v-if="studentNumbers">
                                <td><i v-if="studentNumbers_classType" class="el-icon-arrow-down"
                                       v-on:click="showDateStudentNumber_class_types"></i>
                                    <i v-else class="el-icon-arrow-right"
                                       v-on:click="showDateStudentNumber_class_types"></i>班型
                                </td>
                            </tr>
                            <tr v-for="class_type in class_types" v-if="studentNumbers_classType&&studentNumbers">
                                <td>{{class_type.name}}</td>
                                <td v-for="directDataClassType in directDataClassTypes"
                                    v-if="directDataClassType.classType_id===class_type.id">
                                    {{directDataClassType.dateStudentNumber}}
                                </td>
                            </tr>
                            <!--每日每班主任的学生数-->
                            <tr v-if="studentNumbers">
                                <td><i v-if="studentNumbers_headTeacher" class="el-icon-arrow-down"
                                       v-on:click="showDateStudentNumber_headTeachers"></i>
                                    <i v-else class="el-icon-arrow-right"
                                       v-on:click="showDateStudentNumber_headTeachers"></i>班主任
                                </td>
                            </tr>
                            <tr v-for="headTeacher in headTeachers" v-if="studentNumbers_headTeacher&&studentNumbers">
                                <td>{{headTeacher.name}}</td>
                                <td v-for="directDataHeadTeacher in directDataHeadTeachers"
                                    v-if="directDataHeadTeacher.headTeacher_id===headTeacher.id">
                                    {{directDataHeadTeacher.dateStudentNumber}}
                                </td>
                            </tr>
                            <!--每日整体的学生人次-->
                            <tr>
                                <td>
                                    <i v-if="personTimes" class="el-icon-arrow-down" v-on:click="showDatePersonTime"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDatePersonTime"></i>
                                    每日学生人次
                                </td>
                                <td v-for="directData in directDatas">{{directData.datePersonTime}}</td>
                            </tr>
                            <!--每日每年级学生人次-->
                            <tr v-if="personTimes">
                                <td><i v-if="personTimes_grade" class="el-icon-arrow-down"
                                       v-on:click="showDatePersonTime_grades"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDatePersonTime_grades"></i>年级
                                </td>
                            </tr>
                            <tr v-for="grade in grades" v-if="personTimes_grade&&personTimes">
                                <td>{{grade.name}}</td>
                                <td v-for="directDataGrade in directDataGrades" v-if="directDataGrade.grade_id===grade.id">
                                    {{directDataGrade.datePersonTime}}
                                </td>
                            </tr>
                            <!--每日每科目的学生人次-->
                            <tr v-if="personTimes">
                                <td><i v-if="personTimes_subject" class="el-icon-arrow-down"
                                       v-on:click="showDatePersonTime_subjects"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDatePersonTime_subjects"></i>科目
                                </td>
                            </tr>
                            <tr v-for="subject in subjects" v-if="personTimes_subject&&personTimes">
                                <td>{{subject.name}}</td>
                                <td v-for="directDataSubject in directDataSubjects"
                                    v-if="directDataSubject.subject_id===subject.id">{{directDataSubject.datePersonTime}}
                                </td>
                            </tr>
                            <!--每日每班型的学生人次-->
                            <tr v-if="personTimes">
                                <td><i v-if="personTimes_classType" class="el-icon-arrow-down"
                                       v-on:click="showDatePersonTime_class_types"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDatePersonTime_class_types"></i>班型
                                </td>
                            </tr>
                            <tr v-for="class_type in class_types" v-if="personTimes_classType&&personTimes">
                                <td>{{class_type.name}}</td>
                                <td v-for="directDataClassType in directDataClassTypes"
                                    v-if="directDataClassType.classType_id===class_type.id">
                                    {{directDataClassType.datePersonTime}}
                                </td>
                            </tr>
                            <!--每日每班主任的学生人次-->
                            <tr v-if="personTimes">
                                <td><i v-if="personTimes_headTeacher" class="el-icon-arrow-down"
                                       v-on:click="showDatePersonTime_headTeachers"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDatePersonTime_headTeachers"></i>班主任
                                </td>
                            </tr>
                            <tr v-for="headTeacher in headTeachers" v-if="personTimes_headTeacher&&personTimes">
                                <td>{{headTeacher.name}}</td>
                                <td v-for="directDataHeadTeacher in directDataHeadTeachers"
                                    v-if="directDataHeadTeacher.headTeacher_id===headTeacher_id.id">
                                    {{directDataHeadTeacher.datePersonTime}}
                                </td>
                            </tr>
                            <!--每日整体班级数-->
                            <tr>
                                <td>
                                    <i v-if="classNumbers" class="el-icon-arrow-down" v-on:click="showDateClassNumber"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateClassNumber"></i>
                                    每日班级数
                                </td>
                                <td v-for="directData in directDatas">{{directData.dateClassNumber}}</td>
                            </tr>
                            <!--每日每年级班级数-->
                            <tr v-if="classNumbers">
                                <td><i v-if="classNumbers_grade" class="el-icon-arrow-down"
                                       v-on:click="showDateClassNumber_grades"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateClassNumber_grades"></i>年级
                                </td>
                            </tr>
                            <tr v-for="grade in grades" v-if="classNumbers_grade&&classNumbers">
                                <td>{{grade.name}}</td>
                                <td v-for="directDataGrade in directDataGrades" v-if="directDataGrade.grade_id===grade.id">
                                    {{directDataGrade.dateClassNumber}}
                                </td>
                            </tr>
                            <!--每日每科目的班级数-->
                            <tr v-if="classNumbers">
                                <td><i v-if="classNumbers_subject" class="el-icon-arrow-down"
                                       v-on:click="showDateClassNumber_subjects"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateClassNumber_subjects"></i>科目
                                </td>
                            </tr>
                            <tr v-for="subject in subjects" v-if="classNumbers_subject&&classNumbers">
                                <td>{{subject.name}}</td>
                                <td v-for="directDataSubject in directDataSubjects"
                                    v-if="directDataSubject.subject_id===subject.id">{{directDataSubject.dateClassNumber}}
                                </td>
                            </tr>
                            <!--每日每班型的班级数-->
                            <tr v-if="classNumbers">
                                <td><i v-if="classNumbers_classType" class="el-icon-arrow-down"
                                       v-on:click="showDateClassNumber_class_types"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateClassNumber_class_types"></i>班型
                                </td>
                            </tr>
                            <tr v-for="class_type in class_types" v-if="classNumbers_classType&&classNumbers">
                                <td>{{class_type.name}}</td>
                                <td v-for="directDataClassType in directDataClassTypes"
                                    v-if="directDataClassType.classType_id===class_type.id">
                                    {{directDataClassType.dateClassNumber}}
                                </td>
                            </tr>
                            <!--每日每班主任的班级数-->
                            <tr v-if="classNumbers">
                                <td><i v-if="classNumbers_headTeacher" class="el-icon-arrow-down"
                                       v-on:click="showDateClassNumber_headTeachers"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateClassNumber_headTeachers"></i>班主任
                                </td>
                            </tr>
                            <tr v-for="headTeacher in headTeachers" v-if="classNumbers_headTeacher&&classNumbers">
                                <td>{{headTeacher.name}}</td>
                                <td v-for="directDataHeadTeacher in directDataHeadTeachers"
                                    v-if="directDataHeadTeacher.headTeacher_id===headTeacher.id">
                                    {{directDataHeadTeacher.dateClassNumber}}
                                </td>
                            </tr>
                            <!--每日整体的满班率-->
                            <tr>
                                <td>
                                    <i v-if="fullClassRates" class="el-icon-arrow-down"
                                       v-on:click="showDateFullClassRate"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateFullClassRate"></i>
                                    每日满班率
                                </td>
                                <td v-for="directData in directDatas">{{directData.dateFullClassRatePerCent}}</td>
                            </tr>
                            <!--每日每年级满班率-->
                            <tr v-if="fullClassRates">
                                <td><i v-if="fullClassRates_grade" class="el-icon-arrow-down"
                                       v-on:click="showDateFullClassRate_grades"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateFullClassRate_grades"></i>年级
                                </td>
                            </tr>
                            <tr v-for="grade in grades" v-if="fullClassRates_grade&&fullClassRates">
                                <td>{{grade.name}}</td>
                                <td v-for="directDataGrade in directDataGrades" v-if="directDataGrade.grade_id===grade.id">
                                    {{directDataGrade.dateFullClassRatePerCent}}
                                </td>
                            </tr>
                            <!--每日每科目的满班率-->
                            <tr v-if="fullClassRates">
                                <td><i v-if="fullClassRates_subject" class="el-icon-arrow-down"
                                       v-on:click="showDateFullClassRate_subjects"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="showDateFullClassRate_subjects"></i>科目
                                </td>
                            </tr>
                            <tr v-for="subject in subjects" v-if="fullClassRates_subject&&fullClassRates">
                                <td>{{subject.name}}</td>
                                <td v-for="directDataSubject in directDataSubjects"
                                    v-if="directDataSubject.subject_id===subject.id">
                                    {{directDataSubject.dateFullClassRatePerCent}}
                                </td>
                            </tr>
                            <!--每日每班型的满班率-->
                            <tr v-if="fullClassRates">
                                <td><i v-if="fullClassRates_classType" class="el-icon-arrow-down"
                                       v-on:click="showDateFullClassRate_class_types"></i>
                                    <i v-else class="el-icon-arrow-right"
                                       v-on:click="showDateFullClassRate_class_types"></i>班型
                                </td>
                            </tr>
                            <tr v-for="class_type in class_types" v-if="fullClassRates_classType&&fullClassRates">
                                <td>{{class_type.name}}</td>
                                <td v-for="directDataClassType in directDataClassTypes"
                                    v-if="directDataClassType.classType_id===class_type.id">
                                    {{directDataClassType.dateFullClassRatePerCent}}
                                </td>
                            </tr>
                            <!--每日每个班主任的满班率-->
                            <tr v-if="fullClassRates">
                                <td><i v-if="fullClassRates_headTeacher" class="el-icon-arrow-down"
                                       v-on:click="showDateFullClassRate_headTeachers"></i>
                                    <i v-else class="el-icon-arrow-right"
                                       v-on:click="showDateFullClassRate_headTeachers"></i>班主任
                                </td>
                            </tr>
                            <tr v-for="headTeacher in headTeachers" v-if="fullClassRates_headTeacher&&fullClassRates">
                                <td>{{headTeacher.name}}</td>
                                <td v-for="directDataHeadTeacher in directDataHeadTeachers"
                                    v-if="directDataHeadTeacher.headTeacher_id===headTeacher.id">
                                    {{directDataHeadTeacher.dateFullClassRatePerCent}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="m-portlet">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text">直接数据平均值</h3>
                            </div>
                        </div>
                    </div>

                    <div class="m-portlet__body">
                        <table class="table table-striped" v-loading="loading">
                            <thead>
                            <tr>
                                <th>类型</th>
                                <th>学期平均每日学生数</th>
                                <th>学期平均每日学生人次</th>
                                <th>学期平均每日班级数</th>
                                <th>学期平均班级满班率</th>
                                <th>日期</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><i v-if="averageAll" class="el-icon-arrow-down" v-on:click="handleAverageAll"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="handleAverageAll"></i>整体
                                </td>
                                <td>{{averageDirectDatas.directDatas_studentNumber}}</td>
                                <td>{{averageDirectDatas.directDatas_personTimer}}</td>
                                <td>{{averageDirectDatas.directDatas_classNumber}}</td>
                                <td>{{averageDirectDatas.directDatas_fullClassRate}}</td>
                                <td>{{averageDirectDatas.start_date}}至{{averageDirectDatas.end_date}}</td>
                            </tr>
                            <!--年级平均-->
                            <tr v-if="averageAll">
                                <td><i v-if="averageGrade" class="el-icon-arrow-down" v-on:click="handleAverageGrade"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="handleAverageGrade"></i>年级
                                </td>
                            </tr>
                            <tr v-for="averageDirectDataGrade in averageDirectDataGrades" v-if="averageGrade&&averageAll">
                                <td>{{averageDirectDataGrade.grade}}</td>
                                <td>{{averageDirectDataGrade.directDataGrades_studentNumber}}</td>
                                <td>{{averageDirectDataGrade.directDataGrades_personTimer}}</td>
                                <td>{{averageDirectDataGrade.directDataGrades_classNumber}}</td>
                                <td>{{averageDirectDataGrade.directDataGrades_fullClassRate}}</td>
                                <td>{{averageDirectDataGrade.start_date}}至{{averageDirectDataGrade.end_date}}</td>
                            </tr>
                            <!--科目平均-->
                            <tr v-if="averageAll">
                                <td><i v-if="averageSubject" class="el-icon-arrow-down"
                                       v-on:click="handleAverageSubject"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="handleAverageSubject"></i>学科
                                </td>
                            </tr>
                            <tr v-if="averageSubject&&averageAll"
                                v-for="averageDirectDataSubject in averageDirectDataSubjects">
                                <td>{{averageDirectDataSubject.subject}}</td>
                                <td>{{averageDirectDataSubject.directDataSubjects_studentNumber}}</td>
                                <td>{{averageDirectDataSubject.directDataSubjects_personTimer}}</td>
                                <td>{{averageDirectDataSubject.directDataSubjects_classNumber}}</td>
                                <td>{{averageDirectDataSubject.directDataSubjects_fullClassRate}}</td>
                                <td>{{averageDirectDataSubject.start_date}}-{{averageDirectDataSubject.end_date}}</td>
                            </tr>
                            <!--班型平均-->
                            <tr v-if="averageAll">
                                <td><i v-if="averageClassType" class="el-icon-arrow-down"
                                       v-on:click="handleAverageClassType"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="handleAverageClassType"></i>班型
                                </td>
                            </tr>
                            <tr v-if="averageClassType&&averageAll"
                                v-for="averageDirectDataClassType in averageDirectDataClassTypes">
                                <td>{{averageDirectDataClassType.classType}}</td>
                                <td>{{averageDirectDataClassType.directDataClassTypes_studentNumber}}</td>
                                <td>{{averageDirectDataClassType.directDataClassTypes_personTimer}}</td>
                                <td>{{averageDirectDataClassType.directDataClassTypes_classNumber}}</td>
                                <td>{{averageDirectDataClassType.directDataClassTypes_fullClassRate}}</td>
                                <td>{{averageDirectDataClassType.start_date}}-{{averageDirectDataClassType.end_date}}</td>
                            </tr>
                            <!--班主任平均-->
                            <tr v-if="averageAll">
                                <td><i v-if="averageHeadTeacher" class="el-icon-arrow-down"
                                       v-on:click="handleAverageHeadTeacher"></i>
                                    <i v-else class="el-icon-arrow-right" v-on:click="handleAverageHeadTeacher"></i>班主任
                                </td>
                            </tr>
                            <tr v-if="averageHeadTeacher&&averageAll"
                                v-for="averageDirectDataHeadTeacher in averageDirectDataHeadTeachers">
                                <td>{{averageDirectDataHeadTeacher.headTeacher}}</td>
                                <td>{{averageDirectDataHeadTeacher.directDataHeadTeachers_studentNumber}}</td>
                                <td>{{averageDirectDataHeadTeacher.directDataHeadTeachers_personTimer}}</td>
                                <td>{{averageDirectDataHeadTeacher.directDataHeadTeachers_classNumber}}</td>
                                <td>{{averageDirectDataHeadTeacher.directDataHeadTeachers_fullClassRate}}</td>
                                <td>{{averageDirectDataHeadTeacher.start_date}}-{{averageDirectDataHeadTeacher.end_date}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'

    export default {
        name: "DirectData",
        data() {
            return {
                semesterArr1: [],
                semesterDisabled: false,
                dateDisabled: true,
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                date: '',
                start_date: '',
                end_date: '',
                semesters: [],
                semester: '',

                nowSemester: [],
                grades: [],
                class_types: [],
                headTeachers: [],
                subjects: [],
                directDatas: [],
                directDataClassTypes: [],
                directDataGrades: [],
                directDataHeadTeachers: [],
                directDataSubjects: [],

                studentNumbers: false,
                studentNumbers_grade: false,
                studentNumbers_subject: false,
                studentNumbers_classType: false,
                studentNumbers_headTeacher: false,

                personTimes: false,
                personTimes_grade: false,
                personTimes_subject: false,
                personTimes_classType: false,
                personTimes_headTeacher: false,

                classNumbers: false,
                classNumbers_grade: false,
                classNumbers_subject: false,
                classNumbers_classType: false,
                classNumbers_headTeacher: false,

                fullClassRates: false,
                fullClassRates_grade: false,
                fullClassRates_subject: false,
                fullClassRates_classType: false,
                fullClassRates_headTeacher: false,

                loading: true,

                averageDirectDatas: [],
                averageDirectDataSubjects: [],
                averageDirectDataGrades: [],
                averageDirectDataClassTypes: [],
                averageDirectDataHeadTeachers: [],
                averageGrade: false,
                averageSubject: false,
                averageClassType: false,
                averageAll: false,
                averageHeadTeacher: false,
            }
        },
        created() {
            this.nowSemester = JSON.parse(localStorage.nowSemester);
            this.handleOrganizationIndex();
            this.handleCreate();
            this.handleAverageDirectDataIndex();
        },
        methods: {
            changeDate() {
                if (this.date == null) {
                    this.date = ["1000-01-01", "9999-01-01"]
                }
                this.start_date = this.date[0];
                this.end_date = this.date[1];
                if (this.start_date === "1000-01-01" && this.end_date === "9999-01-01") {
                    this.semesterDisabled = false;
                } else {
                    this.semesterDisabled = true;
                }
                this.loading = true;
                this.handleOrganizationIndex();
            },
            changeSemester() {
                const semester = this.semester;
                this.loading = true;
                if (this.semester in this.semesterArr1) {
                    this.dateDisabled = true;
                } else {
                    this.dateDisabled = false;
                }
                this.handleOrganizationIndex(semester);
                this.handleAverageDirectDataIndex(semester);
            },
            handleCreate() {
                this.$axios.get(store.state.server + '/directData/directData/create?' + '&semester=' + this.semester + '&' + localStorage.baseUrl + '&nowSemester=' + this.nowSemester.id).then(response => {
                    if (response.data.status == 'success') {
                        this.grades = response.data.data.grades;
                        this.class_types = response.data.data.class_types;
                        this.headTeachers = response.data.data.headTeachers;
                        this.subjects = response.data.data.subjects;
                        this.semesters = response.data.data.semesters;
                        this.semester = this.nowSemester.id;
                        const semesterArr = new Array();
                        for (const item of this.semesters) {
                            semesterArr.push(item.id);
                        }
                        this.semesterArr1 = semesterArr;
                    }
                })
            },

            showDateStudentNumber() {
                this.studentNumbers = !this.studentNumbers;
            },
            showDateStudentNumber_grades() {
                this.studentNumbers_grade = !this.studentNumbers_grade;
            },
            showDateStudentNumber_subjects() {
                this.studentNumbers_subject = !this.studentNumbers_subject;
            },
            showDateStudentNumber_class_types() {
                this.studentNumbers_classType = !this.studentNumbers_classType;
            },
            showDateStudentNumber_headTeachers() {
                this.studentNumbers_headTeacher = !this.studentNumbers_headTeacher;
            },

            showDatePersonTime() {
                this.personTimes = !this.personTimes;
            },
            showDatePersonTime_grades() {
                this.personTimes_grade = !this.personTimes_grade;
            },
            showDatePersonTime_subjects() {
                this.personTimes_subject = !this.personTimes_subject;
            },
            showDatePersonTime_class_types() {
                this.personTimes_classType = !this.personTimes_classType;
            },
            showDatePersonTime_headTeachers() {
                this.personTimes_headTeacher = !this.personTimes_headTeacher;
            },

            showDateClassNumber() {
                this.classNumbers = !this.classNumbers;
            },
            showDateClassNumber_grades() {
                this.classNumbers_grade = !this.classNumbers_grade;
            },
            showDateClassNumber_subjects() {
                this.classNumbers_subject = !this.classNumbers_subject;
            },
            showDateClassNumber_class_types() {
                this.classNumbers_classType = !this.classNumbers_classType;
            },
            showDateClassNumber_headTeachers() {
                this.classNumbers_headTeacher = !this.classNumbers_headTeacher;
            },

            showDateFullClassRate() {
                this.fullClassRates = !this.fullClassRates;
            },
            showDateFullClassRate_grades() {
                this.fullClassRates_grade = !this.fullClassRates_grade;
            },
            showDateFullClassRate_subjects() {
                this.fullClassRates_subject = !this.fullClassRates_subject;
            },
            showDateFullClassRate_class_types() {
                this.fullClassRates_classType = !this.fullClassRates_classType;
            },
            showDateFullClassRate_headTeachers() {
                this.fullClassRates_headTeacher = !this.fullClassRates_headTeacher;
            },

            handleAverageAll() {
                this.averageAll = !this.averageAll;
            },
            handleOrganizationIndex() {
                this.$axios.get(store.state.server + '/directData/directData?' + '&semester=' + this.semester + '&' + localStorage.baseUrl + '&nowSemester=' + this.nowSemester.id
                    + '&start_date=' + this.start_date + '&end_date=' + this.end_date).then(response => {
                    if (response.data.status == 'success') {
                        this.directDatas = response.data.data.directDatas;
                        this.directDataClassTypes = response.data.data.directDataClassTypes;
                        this.directDataGrades = response.data.data.directDataGrades;
                        this.directDataHeadTeachers = response.data.data.directDataHeadTeachers;
                        this.directDataSubjects = response.data.data.directDataSubjects;
                        this.total = response.data.data.total;
                        this.loading = false;
                    }
                })
            },

            handleAverageGrade() {
                this.averageGrade = !this.averageGrade;
            },
            handleAverageSubject() {
                this.averageSubject = !this.averageSubject;
            },
            handleAverageClassType() {
                this.averageClassType = !this.averageClassType;
            },
            handleAverageHeadTeacher() {
                this.averageHeadTeacher = !this.averageHeadTeacher;
            },
            handleAverageDirectDataIndex() {
                this.$axios.get(store.state.server + '/directData/averageDirectData?' + '&semester=' + this.semester + '&' + localStorage.baseUrl + '&nowSemester=' + this.nowSemester.id
                    + '&start_date=' + this.start_date + '&end_date=' + this.end_date).then(response => {
                    if (response.data.status == 'success') {
                        this.averageDirectDatas = response.data.data.averageDirectDatas;
                        this.averageDirectDataSubjects = response.data.data.averageDirectDataSubjects;
                        this.averageDirectDataGrades = response.data.data.averageDirectDataGrades;
                        this.averageDirectDataClassTypes = response.data.data.averageDirectDataClassTypes;
                        this.averageDirectDataHeadTeachers = response.data.data.averageDirectDataHeadTeachers;
                        this.loading = false;
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .columndate {
        position: fixed;
    }
</style>
